import { Dispatch } from "redux";
import { setLoading } from "./global";
import TenantService from "service/Tenant";
import { showMessage } from "utilities/helper";
import { TenantPayloadTypes } from "utilities/types/Tenant";

export const getAllTenants = () => async (dispatch: Dispatch) => {
  dispatch(setLoading(true));
  //   dispatch({
  //     type: "SET_TENANT_CURRENT_PAGE",
  //     currentPage: page,
  //   });

  try {
    const data = await TenantService.getAllTetants();

    dispatch(setLoading(false));
    dispatch({ type: "SET_TENANT", value: data.tenants });
    // dispatch({
    //   type: "SET_TENANT_PAGE",
    //   totalPage: !!data.tenants.length ? data.last_page : 1,
    //   limitPage: limit,
    //   lengthPage: !!data.tenants.length ? data.total_data : 1,
    // });
  } catch (err: any) {
    dispatch(setLoading(false));
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const storeTenant =
  (form: TenantPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await TenantService.storeTenant(payload);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllTenants() as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateTenant =
  (tenantId: string, form: TenantPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await TenantService.updateTenant(tenantId, payload);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllTenants() as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteTenant =
  (tenantId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await TenantService.deleteTenant(tenantId);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllTenants() as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const getAllTenantsFilter = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_FILTER_LOADING", value: true });

  try {
    const data = await TenantService.getAllTenantsFilter();

    dispatch({ type: "SET_FILTER_LOADING", value: false });
    dispatch({
      type: "SET_TENANT_FILTER",
      value: data.tenants,
    });
  } catch (err: any) {
    dispatch({ type: "SET_FILTER_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};
